import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FOCUS } from '@bubble-ui/particle-layers';
import { ViewStyles } from '@bubble-ui/primitive-view';
export var getDefaultStyleSheet = _ref => {
  var _keyboardFocusStyle$b, _keyboardFocusStyle$b2;
  var {
    designContext,
    disabled,
    framed,
    keyboardFocused,
    keyboardFocusStyle
  } = _ref;
  var keyboardFocusedBorderOffset = 2;
  var keyboardFocusedBorderRadius = designContext.get('item-touchable/keyboard-focus-corner-radius', {
    framingVariant: framed ? 'framed' : 'default'
  }).value();
  var borderTopRadius = (_keyboardFocusStyle$b = keyboardFocusStyle === null || keyboardFocusStyle === void 0 ? void 0 : keyboardFocusStyle.borderTopRadius) !== null && _keyboardFocusStyle$b !== void 0 ? _keyboardFocusStyle$b : keyboardFocusedBorderRadius;
  var borderBottomRadius = (_keyboardFocusStyle$b2 = keyboardFocusStyle === null || keyboardFocusStyle === void 0 ? void 0 : keyboardFocusStyle.borderBottomRadius) !== null && _keyboardFocusStyle$b2 !== void 0 ? _keyboardFocusStyle$b2 : keyboardFocusedBorderRadius;
  return {
    touchableStyle: {
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      border: 'none',
      cursor: disabled ? 'auto' : 'pointer',
      outline: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      marginBottom: 0,
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString(),
      zIndex: keyboardFocused ? FOCUS : undefined,
      width: '100%'
    },
    keyboardFocusedStyle: {
      borderTopLeftRadius: borderTopRadius > 0 ? borderTopRadius + keyboardFocusedBorderOffset : 0,
      borderTopRightRadius: borderTopRadius > 0 ? borderTopRadius + keyboardFocusedBorderOffset : 0,
      borderBottomLeftRadius: borderBottomRadius > 0 ? borderBottomRadius + keyboardFocusedBorderOffset : 0,
      borderBottomRightRadius: borderBottomRadius > 0 ? borderBottomRadius + keyboardFocusedBorderOffset : 0,
      bottom: -keyboardFocusedBorderOffset,
      left: -keyboardFocusedBorderOffset,
      right: -keyboardFocusedBorderOffset,
      top: -keyboardFocusedBorderOffset,
      position: 'absolute',
      zIndex: 1,
      borderWidth: 2,
      borderColor: designContext.get('item-touchable/keyboard-focus-border-color').toString(),
      pointerEvents: 'none'
    },
    inputStyle: {
      height: '100%',
      width: '100%',
      opacity: 0,
      position: 'absolute',
      top: 0,
      margin: 0,
      padding: 0,
      zIndex: disabled ? -1 : 1,
      cursor: disabled ? 'auto' : 'pointer',
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString()
    },
    labelStyle: _objectSpread(_objectSpread({}, ViewStyles), {}, {
      zIndex: keyboardFocused ? FOCUS : undefined
    }),
    anchorStyle: _objectSpread(_objectSpread({}, ViewStyles), {}, {
      cursor: disabled ? 'auto' : 'pointer',
      textDecoration: 'none'
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map